import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    border-block-end: 1px solid ${cssTheme.default.day.line};
    inline-size: 100%;
  `,
  container: css`
    min-block-size: ${spacing(6)}; // 48px
  `,
  lead: css`
    margin-inline-end: ${spacing(1)}; // 8px
  `,
  pointer: css`
    cursor: pointer;
  `,
  disabled: css`
    opacity: 0.6;
    pointer-events: none;
  `,
  clean: css`
    border-block-end: unset;
  `,
}
